import React, { useEffect, useState } from 'react';
import TeacherSupportModuleComponent from './TeacherSupportComponent';
import { captureException } from '@sentry/react';
import { handleListTeacherSupportForm } from 'store/logs/thunks';

const TeacherSupportModuleAdmin = () => {
  const [teacherSupportData, setTeacherSupportData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTeacherSupportData = async () => {
    try {
      setLoading(true);
      const result = await handleListTeacherSupportForm({ offset: 0, limit: 100 });

      if (result && result.data && result.data.data && Array.isArray(result.data.data)) {
        setTeacherSupportData(result.data.data);
      } else if (result && Array.isArray(result.data)) {
        setTeacherSupportData(result.data);
      } else {
        console.error('Failed to fetch data. Result structure:', result);
        setTeacherSupportData([]);
      }
    } catch (error) {
      console.error('Error in fetchTeacherSupportData:', error);
      captureException(`Error fetching teacher support data: ${error}`);
      setTeacherSupportData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateItem = (itemId, updatedFields) => {
    setTeacherSupportData((prevData) =>
      prevData.map((item) =>
        item.id === itemId ? { ...item, ...updatedFields } : item
      )
    );
  };

  useEffect(() => {
    fetchTeacherSupportData();
  }, []);

  return (
    <TeacherSupportModuleComponent 
      teacherSupportData={teacherSupportData}
      loading={loading}
      onUpdateItem={handleUpdateItem}
    />
  );
};

export default TeacherSupportModuleAdmin;

